var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "sub-title",
    class: [_vm.emailMode ? '' : 'active'],
    on: {
      "click": _vm.toggleView
    }
  }, [_vm._v("工号登录")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-title",
    class: [_vm.emailMode ? 'active' : ''],
    on: {
      "click": _vm.toggleView
    }
  }, [_vm._v("邮箱登录")])]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.ruleForm,
      "autocomplete": "off"
    }
  }, [(!_vm.emailMode) ? _c('el-form-item', {
    key: 1,
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入工号"
    },
    model: {
      value: (_vm.ruleForm.username),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "username", $$v)
      },
      expression: "ruleForm.username"
    }
  })], 1) : _c('el-form-item', {
    key: 2,
    attrs: {
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入邮箱前缀"
    },
    model: {
      value: (_vm.ruleForm.email),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "email", $$v)
      },
      expression: "ruleForm.email"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("@corp.netease.com")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    key: _vm.emailMode ? 3 : 4,
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "auto-complete": "new-password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm('ruleForm')
      }
    },
    model: {
      value: (_vm.ruleForm.password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "password", $$v)
      },
      expression: "ruleForm.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-left mb-20"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "记住密码"
    },
    model: {
      value: (_vm.remember),
      callback: function($$v) {
        _vm.remember = $$v
      },
      expression: "remember"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("登录\n            ")])], 1), _vm._v(" "), _c('el-form-item', [_c('a', {
    attrs: {
      "href": ((_vm.$axios.defaults.baseURL) + "/logindoOpenID.html")
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    }
  }, [_vm._v("OpenId登录")])], 1)])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d509c0f6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/main.vue
// module id = null
// module chunks = 